export interface CategoryPrefix {
  prefix: string;
  categoryName: string;
  remove?: boolean;
}

export const DEFAULT_CATEGORY_PREFIXES: CategoryPrefix[] = [
  // Layout types (remove: true - prefix is stripped, no category created)
  { prefix: 'Base.', categoryName: 'Base', remove: true },
  { prefix: 'Label.', categoryName: 'Label', remove: true },
  { prefix: 'Multi.', categoryName: 'Multi', remove: true },
  { prefix: 'Image.', categoryName: 'Image', remove: true },
  { prefix: 'LabelText.', categoryName: 'LabelText', remove: true },
  { prefix: 'Single.', categoryName: 'Single', remove: true },
  { prefix: 'ImageSingle.', categoryName: 'ImageSingle', remove: true },
  { prefix: 'List.', categoryName: 'List', remove: true },
  { prefix: 'Chain.', categoryName: 'Chain', remove: true },
  // Content generators (remove: true - prefix is stripped, no category created)
  { prefix: 'Eq.', categoryName: 'Equations', remove: true },
  // Name-based groupings (remove: false - prefix creates category)
  { prefix: 'Math_', categoryName: 'Math' },
  { prefix: 'Mat_', categoryName: 'Math' },
  { prefix: 'Cestina_', categoryName: 'Czech' },
  { prefix: 'Czech_', categoryName: 'Czech' },
];

export interface GeneratorPathPart {
  name: string;
  translationKey: string;
}

export function parseGeneratorPath(
  fullName: string,
  prefixes: CategoryPrefix[] = DEFAULT_CATEGORY_PREFIXES
): GeneratorPathPart[] {
  let name = fullName;

  // Step 1: Strip all remove:true prefixes from the beginning
  let strippedPrefixes: string[] = [];
  let changed = true;
  while (changed) {
    changed = false;
    for (const { prefix, remove } of prefixes) {
      if (remove && name.startsWith(prefix)) {
        strippedPrefixes.push(prefix);
        name = name.substring(prefix.length);
        changed = true;
        break;
      }
    }
  }

  // Step 2: If name is empty, use the last stripped prefix (without trailing .) as item name
  if (!name && strippedPrefixes.length > 0) {
    const lastPrefix = strippedPrefixes[strippedPrefixes.length - 1];
    name = lastPrefix.endsWith('.') ? lastPrefix.slice(0, -1) : lastPrefix;
  }

  // Step 3: Split by "__" into segments
  const segments = name.split('__');
  const result: GeneratorPathPart[] = [];

  for (const segment of segments) {
    // Step 4: For each segment, check for remove:false prefixes
    let segmentParts: string[] = [];
    let foundPrefix = false;
    for (const { prefix, categoryName, remove } of prefixes) {
      if (!remove && segment.startsWith(prefix)) {
        segmentParts.push(categoryName);
        const remaining = segment.substring(prefix.length);
        if (remaining) {
          segmentParts.push(remaining);
        }
        foundPrefix = true;
        break;
      }
    }

    if (!foundPrefix) {
      segmentParts.push(segment);
    }

    // Step 5: Build translation keys for this segment
    let accumulated = '';
    for (const part of segmentParts) {
      accumulated = accumulated ? `${accumulated}_${part}` : part;
      const translationKey = `Group.${accumulated}`;
      result.push({
        name: part,
        translationKey,
      });
    }
  }

  return result;
}
